var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04725e-06 13.0208L1.13832e-06 11.9792L17.4406 11.9792L13.174 7.7125L13.9104 6.97604L18.3302 11.3958C18.9396 12.0052 18.9396 12.9958 18.3302 13.6052L13.9104 18.025L13.174 17.2885L17.4406 13.0219L1.04716e-06 13.0219L1.04725e-06 13.0208ZM12.5 1.04167C18.8177 1.04167 23.9583 6.18229 23.9583 12.5C23.9583 18.8177 18.8177 23.9583 12.5 23.9583C7.25625 23.9583 2.84583 20.4323 1.48438 15.625L0.41146 15.625C1.80417 21.0073 6.68854 25 12.5 25C19.3927 25 25 19.3927 25 12.5C25 5.60729 19.3927 -4.90205e-07 12.5 -1.09278e-06C6.68855 -1.60084e-06 1.80417 3.99271 0.41146 9.375L1.48438 9.375C2.84583 4.56771 7.25625 1.04167 12.5 1.04167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.1602b977b5f02af953ebd81c47595d93.svg";
export { ForwardRef as ReactComponent };